import clsx from "clsx";

import { Modal } from "../modal/modal.component";

export function ArcadeInstructionsModal({
  title,
  subtitle,
  image,
  instructions,
  onHideInstructionsModal,
  ...props
}: Omit<React.ComponentProps<typeof Modal>, "children" | "className" | "delay"> & {
  title: string;
  instructions: React.ReactNode;
  image?: string;
  onHideInstructionsModal: () => void;
  subtitle?: string;
}) {
  return (
    <Modal {...props} className={"arcade__instructions-modal"} delay={1000}>
      <div className="arcade__instructions-modal__welcome">Welcome to</div>
      <div className="arcade__instructions-modal__title">{title}</div>
      {subtitle && <div className="arcade__instructions-modal__subtitle">{subtitle}</div>}
      <div className={clsx("arcade__instructions-modal__body", image && "left-alignment")}>
        {image && <img className="arcade__instructions-modal__image" src={image} alt="game modal"/>}
        <div className="arcade__instructions-modal__instructions">{instructions}</div>
      </div>
      <button className="arcade__instructions-modal__start" onClick={onHideInstructionsModal}>
        Play now
      </button>
    </Modal>
  );
}
